// BmsTable.jsx - 电池管理 BMS 遥测数据表
import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };
const fmt0 = v => (v != null && !isNaN(v) ? (typeof v === 'number' ? v.toFixed(2) : v) : '-');
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

export default function BmsTable({ data }) {
  const { t } = useTranslation();

  const columns = [
    { title: 'SN', dataIndex: 'sn', key: 'sn', width: 100, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.globalNo'), dataIndex: 'global_no', key: 'global_no', width: 110, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.devNo'), dataIndex: 'dev_no', key: 'dev_no', width: 100, render: v => v || '-' },
    { title: t('cloud.deviceType'), dataIndex: 'device_type', key: 'device_type', width: 90, render: v => v || '-' },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', width: 70, render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag> },
    { title: t('cloud.state'), dataIndex: 'state', key: 'state', width: 90, render: v => v || '-' },
    { title: t('cloud.intervalStart'), dataIndex: 'interval_start', key: 'interval_start', width: 160, render: fmtTime },
    { title: t('cloud.intervalEnd'), dataIndex: 'interval_end', key: 'interval_end', width: 160, render: fmtTime },
    { title: t('cloud.dataQuality'), dataIndex: 'data_quality', key: 'data_quality', width: 90, render: v => v || '-' },
    { title: t('cloud.mappingSource'), dataIndex: 'mapping_source', key: 'mapping_source', width: 100, render: v => v || '-' },
    { title: t('cloud.soc'), dataIndex: 'soc', key: 'soc', width: 70, render: v => v != null ? `${v}%` : '-' },
    { title: t('cloud.soh'), dataIndex: 'soh', key: 'soh', width: 70, render: v => v != null ? `${v}%` : '-' },
    { title: t('cloud.rackVoltageV'), dataIndex: 'voltage_v', key: 'voltage_v', width: 100, render: v => fmt0(v) },
    { title: t('cloud.rackCurrentA'), dataIndex: 'current_a', key: 'current_a', width: 100, render: v => fmt0(v) },
    { title: t('cloud.powerKw'), dataIndex: 'power_kw', key: 'power_kw', width: 100, render: v => fmt0(v) },
    { title: t('cloud.runState'), dataIndex: 'run_state', key: 'run_state', width: 90, render: v => v ?? '-' },
    { title: t('cloud.runStatus'), dataIndex: 'run_status', key: 'run_status', width: 100, render: v => v || '-' },
    { title: t('cloud.maxChargePowerKw'), dataIndex: 'max_charge_power_kw', key: 'max_charge_power_kw', width: 130, render: v => fmt0(v) },
    { title: t('cloud.availableChargePowerKw'), dataIndex: 'available_charge_power_kw', key: 'available_charge_power_kw', width: 150, render: v => fmt0(v) },
    { title: t('cloud.maxDischargePowerKw'), dataIndex: 'max_discharge_power_kw', key: 'max_discharge_power_kw', width: 140, render: v => fmt0(v) },
    { title: t('cloud.availableDischargePowerKw'), dataIndex: 'available_discharge_power_kw', key: 'available_discharge_power_kw', width: 160, render: v => fmt0(v) },
    { title: t('cloud.maxCellVoltageMv'), dataIndex: 'max_cell_voltage_mv', key: 'max_cell_voltage_mv', width: 130, render: v => v ?? '-' },
    { title: t('cloud.minCellVoltageMv'), dataIndex: 'min_cell_voltage_mv', key: 'min_cell_voltage_mv', width: 130, render: v => v ?? '-' },
    { title: t('cloud.avgCellVoltageV'), dataIndex: 'avg_cell_voltage_v', key: 'avg_cell_voltage_v', width: 130, render: v => fmt0(v) },
    { title: t('cloud.avgTemperatureC'), dataIndex: 'avg_temperature_c', key: 'avg_temperature_c', width: 120, render: v => v != null ? `${v}℃` : '-' },
    { title: t('cloud.maxTemperatureC'), dataIndex: 'max_temperature_c', key: 'max_temperature_c', width: 120, render: v => v != null ? `${v}℃` : '-' },
    { title: t('cloud.minTemperatureC'), dataIndex: 'min_temperature_c', key: 'min_temperature_c', width: 120, render: v => v != null ? `${v}℃` : '-' },
    { title: t('cloud.recordedAt'), dataIndex: 'recorded_at', key: 'recorded_at', width: 160, render: fmtTime },
  ];

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>{t('cloud.telemetryBms')}</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        pagination={{ pageSize: 5, showSizeChanger: false }}
        scroll={{ x: 4000 }}
        style={{ background: 'transparent' }}
      />
    </div>
  );
}
